/*
 * Translation file for locale
 * ---------------------------------
 * Struct:
 *    // Common labeling Block
 *    common: {
 *       lbl1: 'YYYYY'
 *    },
 *    // Pages Block --> Seguir nombres de pages
 *    pages: {
 *       about: {
 *          lbl1: 'ZZZZ'
 *       }
 *    },
 *    // Compnents block --> Seguir misma estructura que ficheros
 *    components: {
 *       home: {
 *          NavigationBarComponent : {
 *              lbl1: 'XXXX'
 *          }
 *       }
 *    }
 *
 * */

export const it = {
    defaultlocale: "it",
    common: {
        appname: "IRIS",
        btn_audit_trail: "Cronologia",
        btn_edit: "Modificare",
        btn_delete: "Elimina",
        btn_cancel: "Annulla",
        btn_ok: "Ok",
        btn_save: "Salvare",
        btn_review: "Revisione",
        btn_remove_review: "Nascondi Revisione",
        btn_view_replies: "Visualizza le risposte",
        lbl_success: "Modifiche salvate con successo",
        lbl_error: "Impossibile salvare le modifiche",
        lbl_edit: "Modificare",
        lbl_delete: "Eliminare",
        lblClose: "Chiudere",
        lblSave: "Salva",
        lblReset: "Ripristina",
        confirmdelete: "Sei sicuro di voler eliminare la selezione corrente?",
        with: "insieme a",
        generatingfile: "Compressing files",
        errorgeneratingfile: "Error on Download",
        downloadingfile: "Downloading file",
        download: "Download",
        modalAudit: {
            lblTitle: "Cambia traccia di controllo",
            msgNoChanges: "Nessuna modifica rilevata.",
            lblUser: "Modifica fatta da:",
            table: {
                colField: "Campo dati",
                colBefore: "Valore prima",
                colAfter: "Valore dopo"
            }
        },
        modalExcel: {
            message: "Link per scaricare",
            link: "Scarica Excel",
            error: "Errore durante la creazione di excel",
            error413: "Limite di download superato. Perfeziona il filtraggio."
        },
        comments: {
            title: "Commenti",
            btn_new: "Inserisci",
            btn_reply: "Rispondere",
            txt_newcomment: "Nuovo commento",
            txt_comment_deleted: "Commento cancellato",
            btn_view_replies: "Visualizza le risposte",
            msg_comm_deleted_confirm:
                "¿Sei sicuro di voler eliminare questo messaggio?",
            msg_comm_added_success: "Comentario añadido",
            msg_comm_added_error: "El comentario no se ha podido añadir",
            msg_comm_edited_success: "Comentario editado",
            msg_comm_edited_error: "El comentario no se ha podido editar",
            msg_comm_deleted_success: "Comentario eliminado",
            msg_comm_deleted_error: "El comentario no se ha podido eliminar"
        },
        documents: {
            TITLE: "Documenti",
            colModel: {
                Name: "nome del documento",
                Description: "Descrizione",
                Type: "Tipo",
                PicType: "Tipo di immagine",
                Date: "Data",
                ExpDate: "Data di scadenza",
                AddReport: "Agg. rapporto",
                IsConfidential: "Confidenziale",
                MinSecLevel: "Min Sec Level",
                toSign: "Firma"
            },
            ToolbarHints: {
                Edit: "Modifica selezione",
                Delete: "Elimina selezione",
                Miniatures: "Visualizza miniature",
                Gallery: "Guarda la galleria",
                Audit: "Aud.",
                Folder: "Aggiungi cartella",
                ListAll: "Visualizza cancellato",
                ListActive: "Visualizza solo attivo",
                Download: "Scarica la selezione",
                BackToDocs: "Torna all'elenco dei documenti"
            },
            AddFolderModal: {
                Title: "Aggiungi cartella",
                Message: "Per favore, inserisci il nome della cartella",
                FolderName: "Nome della cartella",
                msg_toasted_added: "Nuova cartella aggiunta!",
                msg_toasted_no_added:
                    "Si è verificato un problema durante l'aggiunta della nuova cartella, riprovare",
                msg_toasted_zipEmpty: "ZIP VUOTA!!!",
                msg_toasted_no_name:
                    "Il nome deve essere compilato per aggiungere una nuova cartella"
            },
            DownloadZipModal: {
                Title: "Scarica ZIP",
                Message: "Un singolo file ZIP verrà scaricato con",
                Confirm:
                    "documenti. Questo download potrebbe richiedere un minuto, sei sicuro?",
                msg_toasted_zipOK: "ZIP creato!! Download in corso...",
                msg_toasted_zipERROR:
                    "Si è verificato un errore durante la creazione di ZIP. Riprova"
            },
            EditModal: {
                msg_toasted_edited: "Documenti modificati!!",
                msg_toasted_no_edited:
                    "Si è verificato un errore durante la modifica dei documenti. Riprova!!",
                    greaterThan100Mb: "Il documento supera il limite di 100Mb imposto da Adobe per l'elaborazione dei documenti"
            },
            DeleteModal: {
                Message: "Sei sicuro di eliminare i documenti selezionati?",
                msg_toasted_deleted: "Documenti cancellati!!",
                msg_toasted_no_deleted:
                    "Si è verificato un errore durante l'eliminazione dei documenti.Riprova!!"
            },
            DropZone: {
                AddBtn: "Mostra l'area di rilascio dei documenti",
                RemoveBtn: "Nascondi l'area di rilascio dei documenti",
                IsConfidentialBtn: "Contrassegna i documenti allegati come riservati",
                DropFileText: "Rilascia file (non duplicare i nomi)",
                DropFileBtn: "Seleziona il file",
                UploadBtn: "Carica tutti i file",
                UploadedMsg: "Caricato",
                UploadedErrorMsg: "Caricamento fallito",
                ReadyToUploadMsg: "Pronto per il caricamento"
            },
            dueDiligence: {
                title: "Due Diligence"
            }
        }
    },
    pages: {
        about: {
            table: {
                colname: "Nome",
                coltitle: "Alias"
            },
            name: "Informazione"
        },
        sample: {
            name: "Nome",
            type: "Tipologia",
            code: "Codice",
            search: "Ricerca",
            country: "Nazione"
        }
    },
    components: {
        navigation_bar: {
            title_users: "Utenti",
            title_roles: "Ruoli",
            title_profiles: "Profili",
            title_refresh_cache: "Aggiorna cache",
            title_esign: "ESIGN",
            title_esign_JLL: "JLL",
            title_esign_TETRIS: "TÉTRIS",
            title_esign_dashboard: "DASHBOARD",
            title_esign_JLLT: "JLLT",
            title_esign_HR: "HR",
            title_esign_minus: "ESign",
            title_due_diligence: "Due Diligence",
            title_informa: "Informa",
            title_authmappings: "Auth Mappings",
            title_approvers: "ESign Approvers",
            title_healthchecks: "Healthchecks",
            esignmanuales: "ESign Manual",
            esignmanualpt: "Guia de Utilização do E- Sign Portugal",
            esignmanualresidentialpt: "Guia de Utilização do E- Sign Residential",
            esignmanualtetrispt: "Guia de Utilização do E-Sign Tétris"
        },
        dynamicfilters: {
            field: "Proprietà da filtrare",
            operation: "operazione",
            setvalue: "Valor",
            selectvalue: "Valori",
            notvalid: "Questo filtro non è completo"
        },
        pagination: {
            of: "su",
            rows: "righe"
        },
        genericTable: {
            columnList: {
                modalTitle: "Elenco delle colonne disponibili",
                index: "N",
                column: "Colonna",
                isVisible: "Visibile",
                msgConfigSaved: "Configurazione salvata.",
                msgConfigSavedErr: "Errore durante il salvataggio della configurazione."
            }
        },
        esignapproversmanagement: {
            addedsentence: "L'utente {email} sarà aggiunto con il nome {name} come approvatore per la Divisione {area} del soggetto giuridico {legalentity}",
            deletedsentence: "L'utente {email} con nome {name} non sarà più approvato per la Divisione {area} del soggetto giuridico {legalentity}",
            title: "Gestione dei concedenti (JLL)",
            tetrisaddedsentence: "L'utente {email} sarà aggiunto con il nome {name} come approvatore",
            tetrisdeletedsentence: "L'utente {email} con nome {name} non sarà più approvato",
            tetristitle: "Gestione dei concedenti (Tetris)",
            email: "Email",
            name: "Nome",
            area: "Divisione",
            addapprover: "Aggiungi approvanti",
            commit: "Salvare",
            email_validation: "L'e-mail è un campo obbligatorio",
            area_validation: "Divisione è un campo obbligatorio",
            name_validation: "Il nome è un campo obbligatorio",
            addedstage: "Approvatori da aggiungere",
            deletedstage: "Approvatori per rimuovere",
            filtervalidation: "Non è consentito salvare le modifiche mentre i filtri sono attivi",
            itemexists: "Questo oggetto esiste già"
        },
        role: {
            name_label: "Ruolo",
            overview_label: "Descrizione",
            title: "Ruoli",
            edit_title: "Modifica ruolo",
            create_title: "Nuovo ruolo",
            name_validation: "Il nome è obbligatorio",
            overview_validation: "La descrizione è obbligatoria"
        },
        profile: {
            title: "Profili",
            associates_title: "Ruoli associati al profilo",
            name_label: "Profilo",
            overview_label: "Descrizione",
            edit_title: "Modifica Profilo",
            create_title: "Nuovo profilo",
            assign_role_title: "Assegna ruolo",
            name_validation: "Il nome è obbligatorio",
            overview_validation: "La descrizione è obbligatoria"
        },
        user: {
            title: "Utenti",
            associates_title: "Profili associati all'utente",
            name_label: "Utente",
            email_label: "E-mail",
            from_label: "Copia i profili utente",
            to_label: "all'utente",
            edit_title: "Modifica utente",
            create_title: "Nuovo utente",
            assign_profile_title: "Assegna profilo",
            copy_profiles_title: "Copia profili",
            name_validation: "Il nome è obbligatorio",
            email_validation: "L'e-mail è obbligatoria",
            not_same_user_validation:
                "Gli utenti selezionati non devono corrispondere"
        },
        dueDiligence: {
            title: "Due Diligence",
            status: "Stato",
            persontype: "Entità legale/Persona fisica",
            country: "Nazione",
            providertype: "Controparte",
            clienttype: "Tipo di rischio",
            RB: "A basso rischio",
            RM: "Rischio medio",
            RA: "Alto rischio",
            EX: "Escluso",
            PF: "Persona naturale",
            CIF: "CIF",
            country_validation: "Il paese è richiesto",
            CIF_validation: "CIF è obbligatorio",
            clientdescription: "Nome del cliente",
            clientdescription_validation: "Il nome del cliente è obbligatorio",
            providertypeparam: "Controparte",
            providertypeparam_validation: "La controparte è obbligatoria",
            naturalpersonparam: "Tipo",
            naturalpersonparam_validation: "Il tipo è obbligatorio",
            pbcclientparam: "Tipo",
            pbcclientparam_validation: "Il tipo è obbligatorio",
            ispep: "È una persona potenzialmente esposta",
            ispep_validation: "Questo campo è obbligatorio",
            startdate: "Data d'inizio",
            startdate_validation: "La data di inizio è obbligatoria",
            enddate: "Data di chiusura",
            enddate_validation: "La data di chiusura è obbligatoria",
            persontype_validation: "Il tipo di persona è obbligatorio",
            email: "e-mail",
            addemail: "Digita un indirizzo email valido e premi il tasto invio",
            changestatus_title: "Cambiare stato",
            changestatus_validation: "Devi selezionare uno stato da modificare",
            changestatus_unchanged_validation:
                "Impossibile selezionare lo stato corrente",
            nextstatus: "Nuovo stato",
            create_title: "Nuovo Registro",
            update_title: "Modifica Registro",
            statustrack_title: "Modifica traccia stato",
            mailcommentcreate: "L'utente <b>{user}</b> ha aggiunto un commento relativo al file<b> {description} ({cif})</b>.",
            mailcommentedit: "L'utente <b>{user}</b> ha modificato un commento relativo al file<b> {description} ({cif})</b>.",
            mailcommentreply: "L'utente <b>{user}</b> ha risposto a un commento relativo al file<b> {description} ({cif})</b>.",
        },
        statustable: {
            status: "Stato",
            date: "Data",
            deltatime: "Delta tempo",
            username: "Nome utente",
            sendreminder: "inviare promemoria",
            reminderrecentlysent: "Un sollecito è già stato inviato oggi"
        },
        informa: {
            title: "Informa",
            cif: "CIF",
            cif_name: "Nome",
            create_title: "Aggiungi informa CIF",
            cif_validation: "CIF è un valore richiesto",
            cif_name_validation: "Il nome è un valore obbligatorio",
            edit_title: "Modifica Informa CIF"
        },
        esigntetris: {
            estitle: "TÉTRIS ARQUITECTURA S.L.U.",
            ittitle: "Tetris Design & Build Srl",
            pttitle: "FITOUTETRIS S.A.",
            feesrange: "Intervallo di valore del contratto",
            feesvalidation:
                "Le valore del contratto inserite non rientrano nell'intervallo selezionato"
        },
        esigntetrisform: {
            partydetails: "DETTAGLI DELLA PARTE TÉTRIS",
            projectlocation: "Ubicazione progetto / Identificazione progetto",
            regionalclient: "Cliente regionale",
            structuralwork: "Ci sono lavori strutturali/facciate, lavori di impermeabilizzazioni e/o lavori inusuali per il business",
            structuralworkdetail: "Dettaglio",
            protectedbuilding: "Lavori su immobili protetti o sottoposti a vincoli culturali, paesaggistici, ecc.",
            protectedbuildingdetail: "Dettaglio",
            licenseresponsability:
                "Tetris è responsabile per l'oittenimento dei Permessi?",
            licenseresponsabilitydetail: "Dettaglio",
            workguaranteeperiod: "Periodo di garanzia contrattuale / Periodo di responsabilità per difetti",
            workguaranteeperiodrange: "Intervallo",
            bankguarantee: "Garanzia Bancaria o altra garanzia di buona esecuzione?",
            bankguaranteerange: "Intervallo",
            retention: "Ritenuta",
            retentionrange: "Intervallo",
            penalties: "Danni/penalità da ritardo",
            penaltiesamount: "Quantità",
            caponpenalties: "Limite a danni/penalità da ritardo",
            caponpenaltiesrange: "Intervallo",
            includeriskanalisys: "Analisi del rischio d'impresa?",
            riskanalisys: "ANALISI DEL RISCHIO D'IMPRESA",
            anticorruptionclause: "Clausola anticorruzione aggiunta nel contratto",
            pcg: "Parent Company Guarantee",
            pricemodality: "Tipo del Prezzo di contratto",
            pricemodalitydetail: "Dettaglio",
            prepaid: "Pagamento in anticipo",
            prepaidamount: "Quantità",
            prepaidguarantee: "Garanzia sull'anticipo",
            template: "Utilizzando un template TÉTRIS?",
            feesRange: "Intervallo Prezzo",
            fees: "Prezzo del Contratto",
            feesvendor: "Valore del contratto",
            feesrangevalidation:
                "Le valore del contratto inserite non rientrano nell'intervallo selezionato",
            durationofworks: "Durata",
            isocode: "ISO Code",
            tetrissoftcode: "Tetris Soft code",
            clientrequestnumber: "Client request number IRIS",
            legalliabilityyearsmsg: "Da 3 a 10 anni di garanzia legale",
            portugaliabilitymessage: "5 anni di garanzia",
            signee1: "Email firmatario TÉTRIS (1)",
            signee2: "Email firmatario TÉTRIS (2)",
            projectnumber: "Numero di progetto"
        },
        esign: {
            estitle: "JONES LANG LASALLE ESPAÑA, S.A.",
            ittitle: "JONES LANG LASALLE",
            pttitle: "JLL",
            configmessage:
                "Non disponi di autorizzazioni sufficienti per accedere a questa sezione di IRIS o mancano alcuni parametri di configurazione",
            confirmstatuschageinternalsignature:
                "Hai contrassegnato questa richiesta per “approvazione interna“ e non sono consentite modifiche durante la fase di approvazione. Una volta approvata completamente, DEVI caricare il documento firmato esternamente in questa stessa richiesta.",
            confirmstatuschage:
                "Assicurati di aver allegato i documenti per l'approvazione e la firma e di aver completato la domanda.Se accetti, non puoi apportare modifiche.",
            confirmcoveralert:
                "Ricorda che tutti i documenti da firmare devono avere il controllo della firma - da modificare nella finestra del documento -",
            confirmsignature:
                "Sei sicuro di voler inviare i documenti allegati per la firma?",
            confirminternalsignature: "Hai contrassegnato questa richiesta per “approvazione interna“, NON devi premere “invia per la firma“ finché non avrai caricato esternamente il documento firmato da entrambe le parti, poiché la richiesta verrà chiusa senza possibilità di modifica.",
            esignstatuswf: "Stato",
            counterparty: "Controparte",
            persontype: "Persona Giuridica / Persona Fisica",
            legalentity: "Entità Giuridica",
            area: "Divisione",
            segment: "Dipartimento",
            contracttype: "Tipo di Contratto",
            feesrange: "Range della commissione",
            approver: "Approvatore",
            mindate: "Data più remota di creazione",
            maxdate: "Data più recente di creazione",
            cancelconfirm:
                "Inserisci alcuni commenti per giustificare la tua decisione:",
            justifycomment:
                "Inserisci alcuni commenti per giustificare la tua decisione:",
            approvaltext:
                "Dopo aver esaminato il modulo compilato dal richiedente, desideri approvare o rifiutare?.",
            add_approver_title: "Aggiungi approvanti",
            cancel_title: "Annulla transazione",
            approval_title: "Approvare o rifiutare una transazione",
            statustrack_title: "Cronologia dei cambiamenti di stato",
            agreements_title: "Firmatari",
            addapprovertext: "Digita un indirizzo e-mail e premi invio per aggiungere un altro approvatore per questa richiesta:",
            addapproveralert:
                "Attendi l'approvatore aggiuntivo per approvare o rifiutare la richiesta per continuare con il processo di approvazione",
            emaillistvalidation: "È obbligatorio inviare almeno una e-mail",
            create_transaction: "New approval and sign request",
            review_transaction: "Review approval and sign request",
            edit_transaction: "Edit approval and sign request",
            nochangedvalidation: "Lo stato non è cambiato",
            feesvalidation:
                "Le provvigioni inserite non rientrano nell'intervallo selezionato",
            inputsvalidation:
                "I campi obbligatori devono essere compilati e i documenti allegati prima del salvataggio",
            mailcommentcreate: "L'utente <b>{user}</b> ha aggiunto un commento al modulo <b>{description}</b> creato da {solicitant}.",
            mailcommentedit: "L'utente <b>{user}</b> ha modificato un commento sul modulo <b>{description}</b> creato da {solicitant}.",
            mailcommentreply: "L'utente <b>{user}</b> ha risposto al tuo commento sul modulo <b>{description}</b> creato da {solicitant}.",
            approvaltooltip: "Approvare o negare",
            sendtosigntooltip: "Invia per firmare",
            projectnumber: "Numero di progetto"
        },
        dashboards: {
            tetrisTitle: "Numero di contratti per categoria"
        },
        esignform: {
            partydetails: "DATI IDENTIFICATIVI DELLA RICHIESTA",
            counterpartydetails: "DETTAGLI DELLA CONTROPARTE",
            contractdetails: "DETTAGLI CONTRATTO",
            signees: "FIRMATARI",
            description: "Identificatore richiesta",
            solicitantName: "Nome richiedente",
            solicitantMail: "Email richiedente",
            behalf: "Richiesto per conto di ",
            legalEntity: "Società",
            area: "Divisione",
            segment: "Dipartimento",
            subsegment: "Sub-dipartimento",
            approver: "Approvatore /Line Manager",
            oportunityNum: "CRP o Num. Opzionalità",
            feesrangevalidation:
                "Le provvigioni inserite non rientrano nell'intervallo selezionato",
            liability: "Limite di Responsabilità",
            counterparty: "Controparte",
            personType: "Persona Giuridica / Persona Fisica",
            contractType: "Tipo di contratto",
            startDate: "Data Contratto",
            endDate: "Data Fine",
            template: "Utilizzando un template JLL?",
            reviewed: "Rivista da Avvocato",
            object: "Oggetto",
            activeName: "Nome dell'asset / indirizzo completo",
            feesRange: "Soglie provvigione",
            fees: "Provvigioni",
            id: "Documento di identità",
            namesurname: "Nome",
            vat: "CF/VAT",
            companyname: "Nome / Società",

            executed: "Contratto stipulato e firmato",
            onlyInternalApproval: "Contratto solo per approvazione interna",
            counter: "Contratto già firmato dalla contraparte",
            counterPartySignees: "Emails firmatari della controparte",
            signee1: "Firmatario (1)",
            signee2: "Firmatario (2)",
            addMeasures: "Altro...",
            endOfWOrks: "Data Fine",
            endDateNP: "End contract notice",
            projectname: "Nome del progetto",
            leasingpercentage: "% del prezzo di acquisto/locazione"
        },
        stepper: {
            initial_status: "Stato Iniziale",
            cover_completed: "Cover Completa",
            approval_completed: "Approvazione Completa",
            sent_to_sign: "Inviato alla firma",
            signature_completed: "Firma Completa",
            linemanager: "Approval - Line Manager",
            datacontroller: "Approval - Data Controller",
            dccorporate: "Approval - DC Corporate",
            hr: "Approval - HHRR",
            ceo: "Approval - CEO",
            cfo: "Approval - CFO",
            legalandcompliance: "Approval - Legal & Compliance",
            hs: "Approval - Health Safety",
            finance: "Approval - Finance",
            compliance: "Approval - Compliance",
            legal: "Approval - Legal",
            resiblegal: "Approval - Resi. B. Legal",
            leaderbline: "Approval - Leader B. Line",
            hse: "Approval - HSE",
            controller: "Approval - Controller",
            documentcontroller: "Approval - Document Controller"
        },
        approval: {
            comment_validation: "Devi includere un commento"
        },
        counterparty: {
            client: "Client",
            vendor: "Fornitore / Collaboratore"
        },
        ddd: {
            client: {
                title: "DICHIARAZIONE CDD *",
                titleportugal: "DICHIARAZIONE CDD *",
                body: "Dichiaro di aver effettuato tutti i controlli necessari sul fornitore/collaboratore e di aver conservato la documentazione appropriata come richiesto dalla politica aziendale (globale, regionale e locale):",
                li1: "Verifica reputazionale",
                li2: "Verifica finanziaria/solvenza",
                li3: "Verifica Conflitto di interessi",
                li4: "Veririca poteri di firma (PoA)",
                li5: "Verifica Antiriciclaggio / Sanzioni (se applicabile)",
                li6: "Misure aggiuntive: [Testo libero]",
                check1: "I confirm that the Company has capacity to serve this Client.",
                check2:
                    "I confirm that the Client is suitable and do not present risks as a result of the DD.",
                check3:
                    "I declare that I have had in mind, requested and obtained all the necessary approvals (if any), in accordance with the current internal policies of JLL and / or Tétris",
                itcheck1: "Dichiaro che la società ha la capacità di sottoscrivere il presente documento contrattuale e di adempiere agli obblighi in esso contenuti nei confronti del Cliente ",
                itcheck2: "Dichiaro che il Cliente è un soggetto idoneo e corretto e non presenta rischi a valle della DD. "
            },
            vendor: {
                title: "DICHIARAZIONE VDD *",
                titleportugal: "DICHIARAZIONE VDD *",
                body:
                "Dichiaro di aver eseguito tutti le necessarie verifiche sul Fornitore/Collaboratore e di aver conservato idonea documentazione come previsto dalle Policy aziendali (Globali, Regionali, e Locali).",
                li1: "Reputational Risk",
                li2: "Financial/Solvency Risk",
                li3: "Technical/professional Capacity of the Vendor",
                li4: "Adherence to Vendor Code of Conduct (policy 36)",
                li5: "Check sufficent Insurance cover",
                li6: "Check up-to date on payments to Social Security",
                li7: "Check up-to date on payments to Treasury",
                li8: "Additional measures: Free text",
                check1:
                    "I confirm that the Vendor / Collaborator is suitable and do not present risks as a result of the DD.",
                check2:
                    "I declare that I have had in mind, requested and obtained all the necessary approvals (if any), in accordance with the current internal policies of JLL and / or Tétris",
                itcheck1: "Dichiaro che la Società ha la capacità di sottoscrivere il presente documento contrattuale e di adempiere agli obblighi in esso contenuti nei confronti del Fornitore/Collaboratore.",
                itcheck2: "Dichiaro che il Fornitore/Collaboratore è un soggetto idoneo e corretto e non presenta rischi a valle della DD. ",
                itcheck3: "Ho tenuto conto, richiesto e ottenuto tutte le approvazioni necessarie (del caso), in conformità alle politiche interne in vigore di JLL e/o Tetris"
            }

        },
        authorizationmappings: {
            controllertitle: "Controller Mappings",
            actiontitle: "Action Mappings",
            action: "Action",
            controller: "Controller",
            indb: "in Database",
            attribute: "Added attribute",
            assembly: "Exists",
            role: "Role",
            roles: "Roles",
            controllerform: "Controller authorization mappings",
            actionform: "Action authorization mappings",
            rolelist_validation: "Select one role at least",
            controller_validation: "Please type or select a controller",
            action_validation: "Please type or select a action"
        },
        contracttype: {
            nda: "NDA",
            ndainside: "NDA Inside Information",
            advisory: "(Just) Advisory or Consultancy",
            registeredadviser: "Asesor Registrado",
            transactional: "Transactional",
            consultancyandtransactional: "Consultancy & Transactional",
            leasing: "Leasing",
            pdspjmanagement: "PDS Project Management",
            intercompanyagreement: "Intercompany Agreement",
            pdsconsultancy: "PDS Consultancy",
            committeedecisions: "Committee decisions",
            internalsignature: "Internal signature",
            valuations: "Valuations",
            consultancy: "Consultancy",
            subcontractingpm: "Subcontracting PM",
            collaboration: "Collaboration",
            collaborationsp: "Collaboration (Service Provider)",
            otherservices: "Other Services (please indicate)",
            internalpurchases: "Internal Purchases (no revenue related)",
            design: "Progettazione (solo)",
            otherservicesnoconstruction: "Altri servizi relativi a Progettazione (no lavori) ",
            otherservicesrelatedbuild: "Altri servizi relativi a Lavori",
            construction: "Lavori (solo)",
            designandconstruction: "Progettazione e Lavori",
            furnituresupply: "Fornitura di arredi",
            extensionofworkorservice: "Addendum / Variante",
            masterserviceagreement: "Master Service Agreement",
            certificateofmeetings: "Verbali / SAL / Contratti cantiere",
            furniturelogisticsoperator: "Gestione Logistica dei materiali forniti",
            discount: "Sconto per Volume / Rappel / prescrizione",
            thirdpartyintermediaryagreement: "Accordi con terze parti intermediarie",
            purchaseorders: "Purchase Orders  + GT&C (< 10K)",
            purchaseordersit: "Purchase Orders + GT&C",
            instalationofmaterials: "Posa (solo)",
            instalationandmaterials: "Fornitura e posa",
            corporatepurchases: "Acquisti corporate (Support) ",
            dbfurniture: "Design & Build & Furniture",
            budgetinvoice: "Budget/Invoice",
            reciboit: "Ricevuta IT",
            interco: "Contratti Intercompany",
            minutesworkprogress: "Verbali / SAL",
            professionalconsultancy: "Collaborazione professionale (p. iva)",
            ordinediservizio: "Ordine di servizio (MSA)",
            supplyonly: "Fornitura (solo)",
            extensionofworkorserviceit: "Addendum / Variante",
            certificateofmeetingsit: "Verbali / SAL / Contratti cantiere",
            instalationandmaterialsit: "Fornitura e posa",
            freelancecolab: "Collaborazione freelance",
            consultancyService: "Servizio di consulenza",
        },
        contracttypegrp: {
            nda: "NDA",
            advisoryorconsultancy: "Advisory or Consultancy",
            subcontratingpm: "Subcontracting PM",
            collaboration: "Collaboration",
            otherservicesnoconstruction: "Altri servizi relativi a Progettazione (no lavori)",
            otherservicesrelatedbuild: "Altri servizi relativi a Lavori",
            otherservices: "Other Services",
            internalpurchases: "Internal Purchases",
            registeredadviser: "Asesor Registrado",
            transactional: "Transactional",
            consultancyandtransactional: "Consultancy & Transactional",
            leasing: "Leasing",
            pdsprojectmanagement: "PDS Project Management",
            intercompanyagreement: "Intercompany Agreement",
            pdsconsultancy: "PDS Consultancy",
            committeedecisions: "Committee decisions",
            internalsignature: "Internal signature",
            valuations: "Valuations",
            design: "Progettazione (solo)",
            construction: "Lavori (solo)",
            designandconstruction: "Progettazione e Lavori",
            furnituresupply: "Fornitura",
            furniturelogisticsoperator: "Gestione Logistica dei materiali forniti",
            extensionofworkservice: "Addendum / Variante",
            discount: "Sconto per Volume / Rappel / prescrizione",
            masterserviceagreement: "Master Service Agreement",
            thirdpartyintermediaryagreement: "Accordi con terze parti intermediarie",
            purchaseorders: "Purchase Orders  + GT&C (< 10K)",
            purchaseordersit: "Purchase Orders + GT&C",
            instalationofmaterials: "Posa (solo)",
            instalationandmaterials: "Fornitura e posa",
            corporatepurchases: "Acquisti corporate (Support)",
            certificateofmeetings: "Verbali / SAL / Contratti cantiere",
            dbfurniture: "Design & Build & Furniture",
            budgetinvoice: "Budget/Invoice",
            reciboit: "Ricevuta IT",
            interco: "Contratti Intercompany",
            minutesworkprogress: "Verbali / SAL",
            professionalconsultancy: "Collaborazione professionale (p. iva)",
            ordinediservizio: "Ordine di servizio (MSA)",
            supplyonly: "Fornitura (solo)",
            extensionofworkorserviceit: "Addendum/variation",
            certificateofmeetingsit: "Minutes/Works progress/Site related contracts",
            instalationandmaterialsit: "Fornitura e posa",
            freelancecolab: "Collaborazione freelance",
            consultancyService: "Servizio di consulenza",
        }
    },

    app: {
        lbl_title: "Sicurezza",
        lbl_text: "Attivazione della sicurezza, attendere...",
        lbl_back_login: "Accesso all'applicazione...",
        lbl_load_roles: "Ruoli utente...",
        lbl_load_instance: "Caricamento istanza in corso...",
        lbl_error_login:
            "Errore di accesso, se persiste svuota la cache del browser."
    },
    esign_hr: {
        title: "HR ESign Module",
        loading: "Loading...",
        form: {
            reqNumber: "Request Number",
            employee: {
                name: "Employee Name",
                email: "Employee Email"
            },
            society: "Society",
            contractType: "Contract Type",
            bDate: "Send now?",
            launchDate: "Contract Launch Date",
            bJLLsignee: "JLL signature required?",
            jllsigneeEmail1: "JLL Signatory (1)",
            jllsigneeEmail2: "JLL Signatory (2)",
            freeTextTitle: "Email body",
            freeText: "Free text to be included in the email requesting signatures",
            comments: "Comments",
            create: "New Request",
            edit: "Edit Request",
            review: "Review Request",
            dropdownoptions: {
                society: {
                    jll: "Jones Lang LaSalle España",
                    tetris: "Tétris Arquitectura",
                    ifm: "JLL Facility Services (IFM)"
                },
                contracttype: {
                    work: "Contrato de trabajo",
                    signature: "Firmas",
                    append: "Anexos",
                    other: "Otros"
                }
            }
        }
    }
};
